/* ───────────────────────────────────────────────────────────────────────────
   assets/cod-mejoras.js — LAS 5 MEJORAS DEL FORMULARIO CONTRA ENTREGA, ADOSADAS.
   Paquete E1 del PLAN-V2 (data/landing-agente/estudio-v2/PLAN-V2.md §6 E1).
   Contrato y fragmento Liquid: src/landing/FRAGMENTO-COD-MEJORAS.md.

   Qué hace (solo PRESENTACIÓN, nunca dinero ni datos del pedido):
     1. Pasos 1-2-3 con íconos (en Colombia el paso 2 puede llevar la línea de
        entrega que viene del metafield de la TIENDA — doble candado, ver abajo).
        Posición: `pasosPos` 'cabecera' (defecto) | 'campos' (decisión del dueño).
     2. Total en franja de color: SOLO una clase en <html>; el CSS pinta los totales
        que ya existen. La aritmética del anfitrión no se toca.
     3. Reseñas rotando antes de los campos: se pintan TODAS al abrir y se rota solo
        cambiando CLASES (el observador de puente-landing-co.js mira childList +
        characterData, no atributos: así no se despierta cada 4,9 s). Pausa: el botón
        (estado explícito, manda) o el ratón/foco sobre el TEXTO (no sobre el botón).
        Fuera de Colombia se saltan las reseñas que hablen de plazos de entrega.
     4. Nota bajo el WhatsApp, hermana DESPUÉS de su <label> (el error inline del
        anfitrión vive DENTRO del label: quedan apilados error → nota).
     5. Aviso de dirección antes del error y del botón, con estilo informativo.

   🔒 CAMINO DEL DINERO — reglas que este archivo no rompe:
     · Ningún nodo nuevo lleva `name`. Ningún <input>/<select>/<textarea>. El único
       control es un <button type="button"> (pausar reseñas), que no es botón de envío
       ni entra en FormData. ⚠️ En CO y en el carrito ese botón queda DENTRO del <form>:
       sin `type="button"` sería de envío (tocar «pausar» mandaría el pedido y sería el
       botón por defecto del Enter). Lo vigila el test (E1-BTN-*).
     · Si el CSS llega con el formulario ya abierto y el cliente escribiendo, en esa
       apertura no se mete nada ENCIMA de los campos (ni la franja): no se le mueven.
     · Nada se mete DENTRO de lo que el anfitrión repinta (resúmenes, tiers, flash).
     · Todo va en try/catch; si algo falla, ese bloque no aparece y punto.
     · `?variant=` y el `input[name=id]` no se leen ni se escriben aquí.
     · ES5 estricto (un SyntaxError dejaría a la tienda sin formulario: lo vigila
       scripts/test-cod-mejoras.mjs con un recorrido del árbol sintáctico).
     · Ningún texto de país ni de entrega es literal: la línea de entrega sale SOLO
       del metafield de tienda `landing.form.entrega`, y SOLO en sistema `co` con
       moneda COP. En México esa clave ni se lee.

   Encendido: el fragmento Liquid canónico emite
     <script type="application/json" data-cod-mejoras data-sistema data-moneda data-css>
   solo si `shop.metafields.landing.form` está en `prueba|vivo` y el sistema está en
   su lista blanca. Sin eso, este archivo ni se carga.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var W = window;
  var D = document;

  // Idempotente: si el asset se incluye dos veces (dos fragmentos en la misma página),
  // la segunda carga solo vuelve a escanear configs nuevas.
  if (W.__codMejoras && W.__codMejoras.version) {
    try { W.__codMejoras.escanear(); } catch (e) {}
    return;
  }

  var VERSION = 1;
  var LEER_MS = 4500;          // lectura de cada reseña
  var FUNDIDO_MS = 400;        // fundido (lo pinta el CSS)
  var PERIODO_MS = LEER_MS + FUNDIDO_MS;
  var VIGILIA_MS = 300;        // reloj del formulario abierto (rotación + cierre + éxito)
  var MAX_RESENAS = 8;
  // Las largas se SALTAN (nunca se cortan: texto real). Dueño 07-oct: en el formulario la
  // reseña es CORTA, como la del referente (2-3 renglones en negrita en un celular).
  var MAX_CHARS_RESENA = 100;
  var MIN_PALABRAS_RESENA = 6; // «Hermoso» no vende (NOTAS §12.5): solo texto de verdad
  // Nombre que no es un nombre (NOTAS §12.5: nunca «Anónimo»).
  var NOMBRE_VACIO = /^(?:an[oó]nim[oa]s?|anonymous|cliente|usuario|comprador[a]?|n\/?a)\.?$/i;
  // 🔒 RELLENO, NUNCA RESEÑA (dueño 08-oct): los textos que el montaje pone para llegar al
  // mínimo del contrato («Esta pieza todavía no tiene suficientes reseñas…», «Calificó con
  // N estrellas y no dejó comentario escrito.») y el sello «Compra verificada» no son lo
  // que un cliente escribió: en el formulario no salen jamás.
  var TEXTO_RELLENO = /todav[ií]a no tiene suficientes rese[ñn]as|no dej[oó] comentario escrito|compra verificada/i;
  var MAX_CHARS_ENTREGA = 80;
  var MAX_REINSERCIONES = 6;   // por bloque y por apertura: no pelear con el anfitrión
  var CSS_TIMEOUT_MS = 5000;

  // Textos genéricos (sin país, sin tiempos). La única excepción —la entrega de
  // Colombia— NO está aquí: viene del metafield de la tienda.
  var T_PASOS = ['Llenas tus datos', 'Te enviamos tu paquete', 'Pagas al recibir'];
  // Colombia, versión PEQUEÑA (dueño 08-oct): cada etiqueta cabe en UNA línea a 320 px.
  var T_PASOS_CO = ['Llenas tus datos', 'Te lo enviamos', 'Pagas al recibir'];
  var T_PASOS_ARIA = 'Cómo funciona tu pedido';
  // Dueño 08-oct: la nota cabe en UNA línea (medido: 286 px de caja a 320 de ancho) y la
  // flecha va AL PRINCIPIO, apuntando al campo de WhatsApp que queda justo encima.
  var T_NOTA_TEL = '⬆️ Aquí te confirmamos tu pedido';
  // Aviso de dirección (dueño 06-oct NOTAS §12 puntos 2 y 7; ACORTADO el 08-oct: el texto
  // de flipshop se sentía redundante). Sin plazos de entrega ni «llega» (veto E1-TXT-1). Sin «(calle, número y
  // referencias)»: los campos de México son Colonia y Dirección, no se nombran datos que el
  // formulario no pide.
  var T_AVISO = '💥 IMPORTANTE 💥 Revisa que tu dirección esté completa y exacta: así tu entrega es rápida y sin problemas.';
  var T_RESENAS_ARIA = 'Opiniones';
  // Rótulo FIJO + aria-pressed (patrón de botón conmutador): «Pausar opiniones,
  // presionado» = en pausa. Cambiar además el rótulo daría «Reanudar…, presionado».
  var T_PAUSAR = 'Pausar opiniones';

  // 🔒 México NO promete tiempos de entrega (regla del dueño) y eso vale también para
  // lo que dice una reseña dentro del formulario: en sistemas que no son `co` se SALTA
  // (nunca se corta) la reseña que hable de cuánto tardó o de lo rápido que llegó.
  // Se exige CONTEXTO de entrega junto al plazo para no tirar reseñas buenas como
  // «llevo tres semanas usándolo» o «a los tres días me pidió uno» (medido 01-oct:
  // 235 reseñas de cliente MX con 0 plazos; los 3 aciertos del veto ingenuo eran
  // falsos positivos).
  var VETO_ENTREGA = [
    /d[ií]as?\s+h[aá]biles/i,
    /(?:lleg|entreg|recib|tard|demor|env[ií])[^.!?]{0,40}?\b(?:\d+|un|una|uno|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez|once|doce|quince|veinte|pocos|pocas|unos|unas)\s+(?:d[ií]as?|semanas?|horas?|hrs?)\b/i,
    /\b(?:\d+|un|una|uno|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez|once|doce|quince|veinte|pocos|pocas|unos|unas)\s+(?:d[ií]as?|semanas?|horas?|hrs?)\b[^.!?]{0,30}?(?:lleg|entreg|recib)/i,
    /(?:lleg|entreg|recib|env[ií])[^.!?]{0,20}?\b(?:al|el)\s+(?:d[ií]a\s+siguiente|otro\s+d[ií]a|mismo\s+d[ií]a)/i,
    /\blleg[a-záéíóú]*\s+(?:(?:s[uú]per|muy|bien|bastante|s[uú]per\s+bien)\s+)?(?:r[aá]pid|pronto)/i,
    /\b(?:entrega|env[ií]o)s?\s+(?:(?:s[uú]per|muy|bastante)\s+)?(?:r[aá]pid|inmediat|expr[eé]s)/i,
    /\br[aá]pid[a-z]*\s+(?:la\s+|el\s+|en\s+la\s+|en\s+el\s+)?(?:entrega|env[ií]o)/i
  ];
  // Marca de «página de ángulo con marcas contradictorias»: actúa como un ángulo que no
  // casa con ninguna reseña → no hay rotador (jamás se cae a otro público).
  var ANGULO_INCONSISTENTE = '__angulo_inconsistente__';

  // Íconos SVG constantes (sin datos de nadie dentro: innerHTML seguro).
  var SVG_A = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONOS = [
    SVG_A + '<rect x="5" y="3" width="14" height="18" rx="2"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></svg>',
    SVG_A + '<rect x="1" y="6" width="14" height="10" rx="1"/><path d="M15 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    SVG_A + '<rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="3"/><line x1="6" y1="12" x2="6.01" y2="12"/><line x1="18" y1="12" x2="18.01" y2="12"/></svg>'
  ];
  var SVG_PAUSA = '<svg class="codm-ico-pausa" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>' +
    '<svg class="codm-ico-play" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';

  // ── LOS 4 ANFITRIONES ──────────────────────────────────────────────────────
  // Cada uno sabe: dónde está su modal, si está abierto, dónde va cada bloque y si ya
  // está en la pantalla de éxito. Las anclas son las del estudio 02 §3 (verificadas
  // contra el DOM real en scripts/fixtures/cod-mejoras/).
  function primero(raiz, sel) { try { return raiz ? raiz.querySelector(sel) : null; } catch (e) { return null; } }
  function labelDe(raiz, nombre) {
    var c = primero(raiz, '[name="' + nombre + '"]');
    while (c && c !== raiz) {
      if (c.tagName && c.tagName.toUpperCase() === 'LABEL') return c;
      c = c.parentNode;
    }
    return null;
  }
  // Un ancla = { padre, antes } → padre.insertBefore(nodo, antes). `antes` null = al final.
  function tras(el) { return el && el.parentNode ? { padre: el.parentNode, antes: el.nextSibling } : null; }
  function ante(el) { return el && el.parentNode ? { padre: el.parentNode, antes: el } : null; }
  function visible(el) { return !!el && !el.hidden; }
  // Pasos con `pasosPos:"campos"` (decisión del dueño pendiente: hoy los pasos separan
  // «¡OBTENER OFERTA!» de la escalera de ofertas): justo antes de los campos, y antes de
  // nuestras reseñas si ellas también van ahí (orden estable aunque se re-inserten).
  function anteDeCampos(r, selForm) {
    var f = primero(r, selForm);
    var rs = primero(r, '[data-codm="resenas"]');
    if (rs && f && rs.parentNode === f.parentNode) return ante(rs);
    return ante(f);
  }

  var SISTEMAS = {
    'mx2': {
      moneda: 'MXN', perezosa: true,
      raiz: function () { return D.querySelector('[data-lb2-overlay]'); },
      abierto: function (r) { return visible(r); },
      exito: function (r) { var t = primero(r, '[data-lb2-thanks]'); return visible(t); },
      // «LLENA TUS DATOS FÁCIL Y REALIZA UNA COMPRA GARANTIZADA»: con los pasos 1-2-3
      // pintados sobra (NOTAS §12.3). Solo se oculta, nunca se borra.
      subtitulo: function (r) { return primero(r, '[data-lb2-formwrap] > .lb2-head > .lb2-sub'); },
      anclas: {
        pasos: function (r) { return tras(primero(r, '[data-lb2-formwrap] > .lb2-head')); },
        'pasos-campos': function (r) { return anteDeCampos(r, '[data-lb2-form]'); },
        resenas: function (r) { return ante(primero(r, '[data-lb2-form]')); },
        'nota-tel': function (r) { return tras(labelDe(primero(r, '[data-lb2-form]'), 'whatsapp')); },
        'aviso-dir': function (r) { return ante(primero(r, '[data-lb2-form] [data-lb2-error]')); }
      }
    },
    'mx1': {
      moneda: 'MXN', perezosa: true,
      raiz: function () { return D.querySelector('[data-lb-cod-overlay]'); },
      abierto: function (r) { return visible(r); },
      exito: function (r) { var t = primero(r, '[data-lb-cod-thanks]'); return visible(t); },
      anclas: {
        pasos: function (r) { return ante(primero(r, '[data-lb-cod-formwrap] > [data-lb-cod-summary]')); },
        'pasos-campos': function (r) { return anteDeCampos(r, '[data-lb-cod-form]'); },
        resenas: function (r) { return ante(primero(r, '[data-lb-cod-form]')); },
        'nota-tel': function (r) { return tras(labelDe(primero(r, '[data-lb-cod-form]'), 'whatsapp')); },
        'aviso-dir': function (r) { return ante(primero(r, '[data-lb-cod-form] [data-lb-cod-error]')); }
      }
    },
    'co': {
      moneda: 'COP', perezosa: false,
      raiz: function () { return D.querySelector('[data-cco-root] [data-cco-modal]'); },
      abierto: function (r) { return visible(r); },
      exito: function (r) {
        var root = D.querySelector('[data-cco-root]');
        return !!(root && root.classList && root.classList.contains('cco--exito')) || visible(primero(r, '[data-cco-ok]'));
      },
      anclas: {
        pasos: function (r) { return tras(primero(r, '.cco-modal__box > .cco-oferta')); },
        // Colombia (dueño 08-oct): la reseña ARRIBA y los pasos DEBAJO de ella, justo
        // antes del primer campo («Nombre»). Las reseñas van tras `.cco-form__head` (oculto),
        // así que antes del 1.er `label.cco-f` el orden queda reseña → pasos → Nombre, y
        // una re-inserción de cualquiera de los dos vuelve al mismo sitio. Sin campos
        // (anfitrión distinto), el sitio de siempre.
        'pasos-campos': function (r) {
          var campo = primero(primero(r, '[data-cco-form]'), 'label.cco-f');
          return campo ? ante(campo) : anteDeCampos(r, '[data-cco-form]');
        },
        resenas: function (r) {
          var f = primero(r, '[data-cco-form]');
          var head = primero(f, '.cco-form__head');
          if (head) return tras(head);
          var campo = primero(f, 'label.cco-f');
          return campo ? ante(campo) : ante(f);
        },
        'nota-tel': function (r) { return tras(labelDe(primero(r, '[data-cco-form]'), 'whatsapp')); },
        'aviso-dir': function (r) { return ante(primero(r, '[data-cco-form] [data-cco-error]')); }
      }
    },
    'carrito-mx': {
      moneda: 'MXN', perezosa: false,
      raiz: function () { return D.querySelector('[data-cc-root] [data-cc-modal]'); },
      abierto: function (r) { return visible(r); },
      exito: function (r) { return visible(primero(r, '[data-cc-ok]')); },
      anclas: {
        pasos: function (r) { return tras(primero(r, '.cc-modal__box > .cc-sub')); },
        'pasos-campos': function (r) { return anteDeCampos(r, '[data-cc-form]'); },
        resenas: function (r) {
          var f = primero(r, '[data-cc-form]');
          var campo = primero(f, '.cc-row') || primero(f, 'label.cc-f');
          return campo ? ante(campo) : ante(f);
        },
        'nota-tel': function (r) { return tras(labelDe(primero(r, '[data-cc-form]'), 'whatsapp')); },
        'aviso-dir': function (r) { return ante(primero(r, '[data-cc-form] [data-cc-error]')); }
      }
    }
  };
  var ORDEN_BLOQUES = ['pasos', 'resenas', 'nota-tel', 'aviso-dir'];

  // ═══════════════════════════════════════════════════════════════════════════
  // PURAS (expuestas en __codMejoras._puras para el test hermético)
  // ═══════════════════════════════════════════════════════════════════════════
  function esArray(x) { return Object.prototype.toString.call(x) === '[object Array]'; }
  function indice(arr, v) { for (var i = 0; i < arr.length; i++) { if (arr[i] === v) return i; } return -1; }
  function texto(x) { return (typeof x === 'string') ? x.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '') : ''; }

  // ¿Actúa este sistema en esta página? Devuelve { activo, motivo }.
  //   · modo `prueba` actúa SOLO con Shopify.theme.role === 'unpublished' (M1: si
  //     Shopify.theme falta o es otro rol, NO actúa — nunca al revés).
  //   · candado de moneda por sistema: mx* = MXN, co = COP. Si la moneda no se sabe,
  //     no actúa (fail-closed).
  function decidir(cfg, sistema, moneda, theme) {
    if (!cfg || typeof cfg !== 'object' || esArray(cfg)) return { activo: false, motivo: 'sin_config' };
    if (cfg.modo !== 'prueba' && cfg.modo !== 'vivo') return { activo: false, motivo: 'modo_off' };
    if (!Object.prototype.hasOwnProperty.call(SISTEMAS, sistema)) return { activo: false, motivo: 'sistema_desconocido' };
    if (!esArray(cfg.sistemas) || indice(cfg.sistemas, sistema) < 0) return { activo: false, motivo: 'sistema_fuera_de_lista' };
    if (!moneda || moneda !== SISTEMAS[sistema].moneda) return { activo: false, motivo: 'moneda' };
    if (cfg.modo === 'prueba') {
      var rol = (theme && typeof theme === 'object') ? theme.role : null;
      if (rol !== 'unpublished') return { activo: false, motivo: 'prueba_fuera_de_vista_previa' };
    }
    return { activo: true, motivo: 'ok' };
  }

  // Qué mejoras pide el dato. Cada una SOLO con `=== true` (opt-in explícito).
  // `entrega`: doble candado (sistema co Y moneda COP Y texto presente). En cualquier
  // otro sistema la clave ni se lee.
  function mejoras(cfg, sistema, moneda) {
    var c = (cfg && typeof cfg === 'object') ? cfg : {};
    var m = {
      pasos: c.pasos === true,
      totalFranja: c.totalFranja === true,
      resenas: c.resenas === true,
      resenasGeneradas: c.resenasGeneradas === true,
      notaTel: c.notaTel === true,
      avisoDir: c.avisoDir === true,
      // Dónde van los pasos: 'cabecera' (defecto, estudio 02 §3) o 'campos' (justo antes
      // de los campos). Cualquier otro valor = el defecto.
      pasosPos: c.pasosPos === 'campos' ? 'campos' : 'cabecera',
      entrega: null
    };
    if (sistema === 'co' && moneda === 'COP') {
      var e = texto(c.entrega);
      if (e) m.entrega = e.length > MAX_CHARS_ENTREGA ? null : e;
    }
    return m;
  }

  // MEJORA 6 · barra de envío + tira 2x1 del formulario contra entrega de COLOMBIA (ESPEC
  // data/landing-agente/co/form-barra-2x1). Va APARTE de `mejoras()` a propósito: este
  // módulo NO las pinta ni toca el payload — sólo DECIDE si están encendidas, y cod-co.js
  // lo consulta con `CodMejoras.activa('metaEnvio'|'tira2x1')` al abrir. Sólo `co` + COP y
  // sólo con `=== true`; la tira exige además la barra (es la barra quien la anuncia).
  function mejoras2x1(cfg, sistema, moneda) {
    var c = (cfg && typeof cfg === 'object') ? cfg : {};
    var co = (sistema === 'co' && moneda === 'COP');
    var meta = co && c.metaEnvio === true;
    return { metaEnvio: meta, tira2x1: meta && c.tira2x1 === true };
  }
  // SIN A/B (dueño 08-oct, 2.ª decisión): la barra y la tira van al 100 % de los clientes
  // cuando se publique. No hay brazo de control ni nada guardado en el navegador.

  function estrellasValidas(e) {
    var n = Number(e);
    return (isFinite(n) && n >= 1 && n <= 5) ? Math.round(n) : null;
  }
  // Palabras con letra o cifra («100/100⭐️» cuenta; un emoji suelto no).
  function contarPalabras(t) {
    var ps = texto(t).split(' ');
    var n = 0;
    for (var i = 0; i < ps.length; i++) { if (/[0-9A-Za-z\u00C0-\u024F]/.test(ps[i])) n++; }
    return n;
  }
  // Foto del cliente: SOLO https (o `//` de CDN). Cualquier otra cosa → avatar con inicial.
  function fotoValida(f) {
    var u = texto(f);
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (!/^https:\/\/[^\s"'<>()\\]+$/.test(u) || u.length > 600) return null;
    // Las del CDN de Shopify se piden chicas (el avatar mide 40 px; ×3 para pantallas densas).
    if (/^https:\/\/cdn\.shopify\.com\//.test(u) && !/[?&]width=/.test(u)) u += (u.indexOf('?') < 0 ? '?' : '&') + 'width=120';
    return u;
  }
  function normalizarResena(r, origen) {
    if (!r || typeof r !== 'object') return null;
    var n = texto(r.n != null ? r.n : r.nombre);
    var t = texto(r.t != null ? r.t : r.texto);
    if (!n || !t || t.length > MAX_CHARS_RESENA || n.length > 40) return null;
    if (NOMBRE_VACIO.test(n) || contarPalabras(t) < MIN_PALABRAS_RESENA) return null;
    if (TEXTO_RELLENO.test(t)) return null;
    return { n: n, c: texto(r.c != null ? r.c : r.ciudad).slice(0, 40), e: estrellasValidas(r.e != null ? r.e : r.estrellas), t: t, f: fotoValida(r.f != null ? r.f : r.avatar), o: origen };
  }
  // Fuentes:
  //   cfgResenas: [{n,t,e,o}] del fragmento (landing.data.reviews.items). `o` = 'cliente'
  //               o cualquier otra cosa (= escrita por nosotros).
  //   lh:         [{angulo, origen, items:[{nombre,ciudad,estrellas,texto}]}] de los
  //               <script data-lh-resenas-form> de la híbrida (P0).
  //   angulo:     data-lh-angulo de la página (null/'base' = no es página de ángulo).
  // Reglas (PLAN-V2 E1 §3, M13/M-5):
  //   · lo que no es de cliente solo entra con resenasGeneradas:true (UN interruptor
  //     gobierna las dos fuentes);
  //   · página de ángulo: SOLO las de su ángulo. Sin ellas, no hay bloque — jamás se
  //     cae a reseñas de otro público;
  //   · resto: cliente del dato → nuestras de la base → generadas del dato;
  //   · vetarEntrega (todo sistema que no sea `co`): se salta la reseña que hable de
  //     plazos o rapidez de entrega (hablaDeEntrega).
  function hablaDeEntrega(t) {
    if (typeof t !== 'string' || !t) return false;
    for (var i = 0; i < VETO_ENTREGA.length; i++) { if (VETO_ENTREGA[i].test(t)) return true; }
    return false;
  }
  //   · tienda (solo Colombia): las MEJORES reseñas REALES de clientes de toda la tienda
  //     (metafield de tienda `landing.resenas_tienda`, curado por
  //     scripts/resenas-tienda-co.mjs). Entran SOLO si la pieza no tiene ni una reseña
  //     de cliente válida; sin ellas tampoco, no hay bloque.
  function seleccionarResenas(cfgResenas, lh, angulo, resenasGeneradas, vetarEntrega, tienda) {
    var out = [];
    var vistos = {};
    function meter(r) {
      if (!r || out.length >= MAX_RESENAS) return;
      if (r.o !== 'cliente' && resenasGeneradas !== true) return;
      if (vetarEntrega !== false && hablaDeEntrega(r.t)) return;
      var k = r.t.toLowerCase();
      if (vistos[k]) return;
      vistos[k] = true;
      out.push(r);
    }
    var i, j, f;
    var lista = esArray(lh) ? lh : [];
    var esAngulo = !!(angulo && angulo !== 'base');
    if (esAngulo) {
      for (i = 0; i < lista.length; i++) {
        f = lista[i] || {};
        if (f.angulo !== angulo || !esArray(f.items)) continue;
        for (j = 0; j < f.items.length; j++) meter(normalizarResena(f.items[j], f.origen === 'cliente' ? 'cliente' : 'nuestras'));
      }
      return out;
    }
    var cfgL = esArray(cfgResenas) ? cfgResenas : [];
    for (i = 0; i < cfgL.length; i++) {
      if (cfgL[i] && cfgL[i].o === 'cliente') meter(normalizarResena(cfgL[i], 'cliente'));
    }
    for (i = 0; i < lista.length; i++) {
      f = lista[i] || {};
      if ((f.angulo && f.angulo !== 'base') || !esArray(f.items)) continue;
      for (j = 0; j < f.items.length; j++) meter(normalizarResena(f.items[j], f.origen === 'cliente' ? 'cliente' : 'nuestras'));
    }
    var hayCliente = false;
    for (i = 0; i < out.length; i++) { if (out[i].o === 'cliente') hayCliente = true; }
    var tL = esArray(tienda) ? tienda : [];
    if (!hayCliente && tL.length) {
      // Sin reseñas propias de cliente: las reales de la tienda MANDAN sobre las escritas
      // por nosotros (real > generada); el bloque nunca mezcla las dos cosas.
      out = []; vistos = {};
      for (i = 0; i < tL.length; i++) meter(normalizarResena(tL[i], 'cliente'));
      if (out.length) return out;
    }
    for (i = 0; i < cfgL.length; i++) {
      if (cfgL[i] && cfgL[i].o !== 'cliente') meter(normalizarResena(cfgL[i], 'generada'));
    }
    return out;
  }

  // Grupo de control (D3). pct 0 → siempre 'mejoras' y no se escribe nada. Unidad =
  // visita-día (la misma del A/B): se recuerda por día en localStorage si se puede.
  function grupoDe(pct, hoy, guardado, azar) {
    var p = Number(pct);
    if (!isFinite(p) || p <= 0) return 'mejoras';
    if (p > 100) p = 100;
    if (typeof guardado === 'string' && guardado.indexOf(hoy + ':') === 0) {
      var g = guardado.slice(hoy.length + 1);
      if (g === 'control' || g === 'mejoras') return g;
    }
    return (azar * 100 < p) ? 'control' : 'mejoras';
  }

  // Índice de la reseña visible a partir del tiempo de lectura acumulado.
  function indiceRotacion(acumuladoMs, n) {
    if (!n || n < 2 || !(acumuladoMs >= 0)) return 0;
    return Math.floor(acumuladoMs / PERIODO_MS) % n;
  }

  // Ángulo de la página a partir de TODAS sus marcas (no de la primera: una sección
  // sin `settings.angulo` dice `base` y, si fuera la primera, la página de ángulo se
  // leería como base y mezclaría reseñas de otro público).
  //   · ninguna marca o solo `base` → null (no es página de ángulo);
  //   · un único ángulo ≠ base (aunque haya secciones `base` delante) → ese ángulo;
  //   · dos ángulos distintos → ANGULO_INCONSISTENTE (sin rotador; la QA ya da rojo).
  function anguloDeMarcas(vals) {
    var ang = null;
    var lista = esArray(vals) ? vals : [];
    for (var i = 0; i < lista.length; i++) {
      var v = texto(lista[i]);
      if (!v || v === 'base') continue;
      if (ang === null) ang = v;
      else if (ang !== v) return ANGULO_INCONSISTENTE;
    }
    return ang;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // DOM
  // ═══════════════════════════════════════════════════════════════════════════
  function el(tag, clase, txt) {
    var n = D.createElement(tag);
    if (clase) n.className = clase;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function marcar(n, tipo, sistema) {
    n.setAttribute('data-codm', tipo);
    n.setAttribute('data-codm-s', sistema);
    return n;
  }

  function nodoPasos(sistema, m) {
    var ol = marcar(el('ol', 'codm codm-pasos'), 'pasos', sistema);
    ol.setAttribute('aria-label', T_PASOS_ARIA);
    var tp = sistema === 'co' ? T_PASOS_CO : T_PASOS;
    for (var i = 0; i < tp.length; i++) {
      var li = el('li', 'codm-pasos__p');
      var ic = el('span', 'codm-pasos__ic');
      ic.setAttribute('aria-hidden', 'true');
      ic.innerHTML = ICONOS[i];
      var num = el('span', 'codm-pasos__n', String(i + 1));
      num.setAttribute('aria-hidden', 'true');
      ic.appendChild(num);
      li.appendChild(ic);
      li.appendChild(el('span', 'codm-pasos__t', tp[i]));
      // 🔒 La línea de entrega: solo el paso 2, solo si `mejoras()` la dejó pasar
      // (sistema co + COP + texto del metafield de la tienda).
      if (i === 1 && m.entrega) li.appendChild(el('span', 'codm-pasos__det', m.entrega));
      ol.appendChild(li);
    }
    return ol;
  }

  function nodoResenas(sistema, lista, quieto) {
    var box = marcar(el('div', 'codm codm-resenas' + (quieto ? ' codm-resenas--quieto' : '')), 'resenas', sistema);
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', T_RESENAS_ARIA);
    var pista = el('div', 'codm-resenas__pista');
    for (var i = 0; i < lista.length; i++) {
      var r = lista[i];
      var s = el('div', 'codm-resena' + (i === 0 ? ' codm-resena--on' : ''));
      s.setAttribute('data-codm-i', String(i));
      // Tarjeta COMPACTA estilo flipshop (NOTAS §12.6 + dueño 07-oct): avatar chico a la
      // izquierda; a su lado el NOMBRE en píldora y, debajo, estrellas pequeñas y ciudad;
      // abajo el texto corto en negrita, centrado.
      var cab = el('div', 'codm-resena__cab');
      cab.appendChild(nodoAvatar(r));
      var quien = el('div', 'codm-resena__quien');
      quien.appendChild(el('span', 'codm-resena__autor', r.n));
      if (r.e || r.c) {
        var meta = el('div', 'codm-resena__meta');
        if (r.e) {
          var est = '';
          for (var k = 0; k < r.e; k++) est += '★';
          var e = el('span', 'codm-resena__estrellas', est);
          e.setAttribute('role', 'img');
          e.setAttribute('aria-label', r.e + ' de 5 estrellas');
          meta.appendChild(e);
        }
        if (r.c) meta.appendChild(el('span', 'codm-resena__ciudad', r.c));
        quien.appendChild(meta);
      }
      cab.appendChild(quien);
      s.appendChild(cab);
      s.appendChild(el('div', 'codm-resena__texto', '“' + r.t + '”'));
      pista.appendChild(s);
    }
    box.appendChild(pista);
    if (!quieto && lista.length > 1) {
      var b = el('button', 'codm-resenas__pausa');
      b.type = 'button';
      b.setAttribute('data-codm-pausa', '');
      b.setAttribute('aria-label', T_PAUSAR);
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = SVG_PAUSA;
      box.appendChild(b);
    }
    return box;
  }

  // Avatar: la foto del cliente si la trae; si no (o si no carga), su inicial.
  function inicialDe(n) {
    var m = texto(n).match(/[0-9A-Za-z\u00C0-\u024F]/);
    return m ? m[0].toUpperCase() : '★';
  }
  function nodoAvatar(r) {
    var av = el('span', 'codm-resena__av');
    av.setAttribute('aria-hidden', 'true');
    var ini = el('span', 'codm-resena__ini', inicialDe(r.n));
    av.appendChild(ini);
    if (r.f) {
      var img = D.createElement('img');
      img.className = 'codm-resena__foto';
      img.alt = '';
      img.width = 40;
      img.height = 40;
      img.decoding = 'async';
      img.setAttribute('referrerpolicy', 'no-referrer');
      img.addEventListener('error', function () { try { if (img.parentNode) img.parentNode.removeChild(img); } catch (e) {} });
      img.src = r.f;
      av.appendChild(img);
    }
    return av;
  }

  function nodoNotaTel(sistema) {
    return marcar(el('p', 'codm codm-nota-tel', T_NOTA_TEL), 'nota-tel', sistema);
  }
  function nodoAvisoDir(sistema) {
    var p = marcar(el('p', 'codm codm-aviso-dir'), 'aviso-dir', sistema);
    p.appendChild(el('strong', null, T_AVISO));
    return p;
  }

  // ── CSS: se pide una vez, NO bloquea el pintado (media=print → all) ──────────
  var css = { estado: 'nada', url: null, cbs: [] };
  function cargarCss(url, cb) {
    if (css.estado === 'ok') { if (cb) cb(true); return; }
    if (css.estado === 'error') { if (cb) cb(false); return; }
    if (cb) css.cbs.push(cb);
    if (css.estado === 'cargando') return;
    if (!url) { finCss(false); return; }
    css.estado = 'cargando';
    css.url = url;
    var l = D.createElement('link');
    var hecho = false;
    function fin(ok) {
      if (hecho) return;
      hecho = true;
      try { l.media = 'all'; } catch (e) {}
      finCss(ok);
    }
    try {
      l.rel = 'stylesheet';
      l.href = url;
      l.media = 'print';
      l.setAttribute('data-codm-css', '');
      l.onload = function () { fin(true); };
      l.onerror = function () { fin(false); };
      setTimeout(function () { fin(!!l.sheet); }, CSS_TIMEOUT_MS);
      (D.head || D.documentElement).appendChild(l);
    } catch (e) { fin(false); }
  }
  // Avisar cuando el CSS esté, SIN pedirlo (lo pide la precarga en ocioso o la apertura).
  function alCargarCss(cb) {
    if (css.estado === 'ok') { cb(true); return; }
    if (css.estado === 'error') { cb(false); return; }
    css.cbs.push(cb);
  }
  function finCss(ok) {
    css.estado = ok ? 'ok' : 'error';
    API.css = css.estado;
    var cbs = css.cbs;
    css.cbs = [];
    for (var i = 0; i < cbs.length; i++) { try { cbs[i](ok); } catch (e) {} }
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // INSTANCIA (una por sistema en la página)
  // ═══════════════════════════════════════════════════════════════════════════
  function Instancia(sistema, cfgNodo) {
    this.sistema = sistema;
    this.ad = SISTEMAS[sistema];
    this.cfgNodo = cfgNodo;
    this.estado = { activo: false, motivo: 'iniciando', grupo: 'mejoras', abierto: false, rotando: false, insertados: {}, reinserciones: 0, fallos: {} };
    this.raiz = null;
    this.obsCuerpo = null;
    this.obsRaiz = null;
    this.obsContenido = null;
    this.vigilia = null;
    this.rot = { acumulado: 0, ultimo: 0, pausado: false, hover: false, foco: false, idx: 0 };
    this.reins = {};
    this.resenas = [];
    this.m = null;
    this.cssUrl = null;
    // El CSS llegó TARDE (formulario ya abierto) y el cliente ya estaba usando los campos:
    // en ESA apertura no se mete nada encima de los campos (no se le mueven mientras
    // escribe). Se reinicia en cada apertura.
    this.tecleo = false;
    this.soloAbajo = false;
    this.franjaPendiente = false;
  }

  Instancia.prototype.iniciar = function () {
    var datos = null;
    try { datos = JSON.parse(this.cfgNodo.textContent || 'null'); } catch (e) { datos = null; }
    var cfg = datos && datos.config;
    var moneda = texto(this.cfgNodo.getAttribute('data-moneda')).toUpperCase();
    if (!moneda) {
      try { moneda = texto(W.Shopify && W.Shopify.currency && W.Shopify.currency.active).toUpperCase(); } catch (e) { moneda = ''; }
    }
    var theme = null;
    try { theme = (W.Shopify && W.Shopify.theme) || null; } catch (e) { theme = null; }
    var d = decidir(cfg, this.sistema, moneda, theme);
    this.estado.motivo = d.motivo;
    if (!d.activo) return;

    // Grupo de control (D3). Con pct 0 no se toca nada.
    var pct = cfg && cfg.control ? cfg.control.pct : 0;
    if (Number(pct) > 0) {
      var hoy = hoyLocal();
      var guardado = null;
      try { guardado = W.localStorage.getItem('codm_grupo'); } catch (e) {}
      var g = grupoDe(pct, hoy, guardado, Math.random());
      try { W.localStorage.setItem('codm_grupo', hoy + ':' + g); } catch (e) {}
      this.estado.grupo = g;
      // Para que E2 lo lleve en /parcial y /ordenar (y E4 a su registro): grupo + día de
      // asignación (unidad = visita-día). Sin esto el control NO se puede medir (D3).
      try { D.documentElement.setAttribute('data-codm-grupo', g); D.documentElement.setAttribute('data-codm-asignado', hoy); } catch (e) {}
      if (g === 'control') { this.estado.motivo = 'grupo_control'; return; }
    }

    this.m = mejoras(cfg, this.sistema, moneda);
    this.m2 = mejoras2x1(cfg, this.sistema, moneda);
    // El formulario conserva la piel CLARA de siempre de cada tienda (dueño 07-oct: la paleta
    // oscura de la marca va a la LANDING, no al formulario). Aquí no se pinta ninguna marca.
    this.cssUrl = this.cfgNodo.getAttribute('data-css') || null;
    if (this.m.resenas) {
      // 🔒 Solo Colombia puede hablar de plazos de entrega; en cualquier otro sistema se
      // saltan las reseñas que lo hagan.
      this.resenas = seleccionarResenas(datos.resenas, leerResenasHibrida(), anguloDePagina(), this.m.resenasGeneradas, this.sistema !== 'co',
        this.sistema === 'co' ? leerResenasTienda() : null);
    }
    this.estado.activo = true;

    // CSS en ocioso tras `load` (no bloquea nada) — y, si alguien abre antes, al abrir.
    var yo = this;
    precargarCss(this.cssUrl);
    if (this.m.totalFranja) {
      alCargarCss(function (ok) { if (ok) yo.ponerFranja(); });
    }
    this.enganchar();
    this.delegar();
  };

  // Busca el modal (los overlays de México nacen al primer clic) y escucha su `hidden`.
  Instancia.prototype.enganchar = function () {
    var yo = this;
    var r = null;
    try { r = this.ad.raiz(); } catch (e) { r = null; }
    if (r) { this.ponerRaiz(r); return; }
    if (this.ad.perezosa && typeof W.MutationObserver === 'function' && D.body && !this.obsCuerpo) {
      // SOLO hijos directos de <body>, sin subtree: barato y no ve nada del formulario.
      this.obsCuerpo = new W.MutationObserver(function () {
        var rr = null;
        try { rr = yo.ad.raiz(); } catch (e) { rr = null; }
        if (rr) {
          try { yo.obsCuerpo.disconnect(); } catch (e) {}
          yo.obsCuerpo = null;
          yo.ponerRaiz(rr);
        }
      });
      try { this.obsCuerpo.observe(D.body, { childList: true }); } catch (e) {}
    }
  };

  Instancia.prototype.ponerRaiz = function (r) {
    var yo = this;
    if (this.obsRaiz) { try { this.obsRaiz.disconnect(); } catch (e) {} }
    this.raiz = r;
    if (typeof W.MutationObserver === 'function') {
      this.obsRaiz = new W.MutationObserver(function () { yo.revisar(); });
      try { this.obsRaiz.observe(r, { attributes: true, attributeFilter: ['hidden'] }); } catch (e) {}
    }
    this.revisar();
  };

  Instancia.prototype.revisar = function () {
    var abierto = false;
    try { abierto = !!(this.raiz && this.ad.abierto(this.raiz)); } catch (e) { abierto = false; }
    if (abierto && !this.estado.abierto) this.abrir();
    else if (!abierto && this.estado.abierto) this.cerrar();
  };

  Instancia.prototype.abrir = function () {
    var yo = this;
    this.estado.abierto = true;
    this.reins = {};
    this.rot.acumulado = 0;
    this.rot.idx = 0;
    this.rot.ultimo = Date.now();
    this.tecleo = false;
    this.soloAbajo = false;
    this.estado.soloAbajo = false;
    var cssYa = (css.estado === 'ok');
    cargarCss(this.cssUrl, function (ok) {
      if (!ok || !yo.estado.abierto) return;
      // CSS tardío + cliente ya escribiendo/tocando campos → en esta apertura solo lo
      // que va a la altura o debajo de los campos (nota y aviso); pasos y reseñas, en
      // la siguiente. Así no se le empujan los campos ~180 px mientras escribe.
      if (!cssYa && yo.tecleo) { yo.soloAbajo = true; yo.estado.soloAbajo = true; }
      yo.asegurar();
      yo.observarContenido();
      yo.arrancarVigilia();
    });
  };

  Instancia.prototype.cerrar = function () {
    this.estado.abierto = false;
    if (this.vigilia) { clearTimeout(this.vigilia); this.vigilia = null; }
    this.estado.rotando = false;
    if (this.obsContenido) { try { this.obsContenido.disconnect(); } catch (e) {} this.obsContenido = null; }
    if (this.franjaPendiente) this.ponerFranja();
  };

  // La franja agranda unos px la fila del total: si el CSS llega con el cliente
  // escribiendo en el formulario abierto, se pone al cerrarlo (no le mueve los campos).
  Instancia.prototype.ponerFranja = function () {
    if (this.estado.abierto && this.tecleo) { this.franjaPendiente = true; return; }
    this.franjaPendiente = false;
    try { D.documentElement.classList.add('codm-franja'); } catch (e) {}
  };

  Instancia.prototype.quiere = function (tipo) {
    var m = this.m || {};
    if (tipo === 'pasos') return m.pasos && !this.soloAbajo;
    if (tipo === 'resenas') return m.resenas && this.resenas.length > 0 && !this.soloAbajo;
    if (tipo === 'nota-tel') return m.notaTel;
    if (tipo === 'aviso-dir') return m.avisoDir;
    return false;
  };

  Instancia.prototype.nodo = function (tipo) {
    if (tipo === 'pasos') return nodoPasos(this.sistema, this.m);
    if (tipo === 'resenas') return nodoResenas(this.sistema, this.resenas, movimientoReducido());
    if (tipo === 'nota-tel') return nodoNotaTel(this.sistema);
    if (tipo === 'aviso-dir') return nodoAvisoDir(this.sistema);
    return null;
  };

  // Idempotente: solo inserta lo que falta. Con tope de re-inserciones por apertura.
  Instancia.prototype.asegurar = function () {
    var r = this.raiz;
    if (!r || !this.estado.abierto) return;
    for (var i = 0; i < ORDEN_BLOQUES.length; i++) {
      var tipo = ORDEN_BLOQUES[i];
      try {
        if (!this.quiere(tipo)) continue;
        if (r.querySelector('[data-codm="' + tipo + '"]')) continue;
        var n = this.reins[tipo] || 0;
        if (n >= MAX_REINSERCIONES) continue;
        var clave = (tipo === 'pasos' && this.m && this.m.pasosPos === 'campos') ? 'pasos-campos' : tipo;
        var a = this.ad.anclas[clave](r);
        if (!a || !a.padre) { this.estado.fallos[tipo] = 'sin_ancla'; continue; }
        var nodo = this.nodo(tipo);
        if (!nodo) continue;
        a.padre.insertBefore(nodo, a.antes || null);
        if (n > 0) this.estado.reinserciones++;
        this.reins[tipo] = n + 1;
        this.estado.insertados[tipo] = true;
        if (tipo === 'resenas') this.pintarIndice(this.rot.idx, true);
      } catch (e) {
        this.estado.fallos[tipo] = 'error';
      }
    }
    this.ocultarSubtitulo();
  };

  // Con los pasos pintados, el subtítulo del anfitrión es redundante: se oculta (hidden +
  // display:none en línea, porque un tema puede dar display a <p>). Sin pasos, se queda.
  Instancia.prototype.ocultarSubtitulo = function () {
    try {
      if (!this.ad.subtitulo || !this.raiz || !this.raiz.querySelector('[data-codm="pasos"]')) return;
      var sub = this.ad.subtitulo(this.raiz);
      if (!sub || sub.getAttribute('data-codm-oculto') === '1') return;
      sub.hidden = true;
      sub.style.display = 'none';
      sub.setAttribute('data-codm-oculto', '1');
      this.estado.subtituloOculto = true;
    } catch (e) {}
  };

  // Observa SOLO los padres de nuestros bloques, SOLO childList (sin subtree, sin
  // atributos, sin texto). Si el anfitrión se lleva un bloque, vuelve a su sitio.
  Instancia.prototype.observarContenido = function () {
    var yo = this;
    if (typeof W.MutationObserver !== 'function' || !this.raiz) return;
    if (this.obsContenido) { try { this.obsContenido.disconnect(); } catch (e) {} }
    var padres = [];
    var nodos = this.raiz.querySelectorAll('[data-codm]');
    for (var i = 0; i < nodos.length; i++) {
      var p = nodos[i].parentNode;
      if (p && indice(padres, p) < 0) padres.push(p);
    }
    if (!padres.length) return;
    var pendiente = false;
    this.obsContenido = new W.MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () {
        pendiente = false;
        try { yo.asegurar(); } catch (e) {}
      }, 0);
    });
    for (var j = 0; j < padres.length; j++) {
      try { this.obsContenido.observe(padres[j], { childList: true }); } catch (e) {}
    }
  };

  // Delegación en el documento (sobrevive a que el anfitrión cambie nuestros nodos).
  Instancia.prototype.delegar = function () {
    var yo = this;
    function coincide(n, sel) {
      var f = n.matches || n.msMatchesSelector || n.webkitMatchesSelector;
      try { return f ? f.call(n, sel) : false; } catch (e) { return false; }
    }
    function dentroDe(t, sel) {
      while (t && t !== D) {
        if (t.nodeType === 1 && coincide(t, sel)) return t;
        t = t.parentNode;
      }
      return null;
    }
    function propio(t) {
      var box = dentroDe(t, '[data-codm="resenas"]');
      return (box && box.getAttribute('data-codm-s') === yo.sistema) ? box : null;
    }
    // Solo la zona de LECTURA (la pista con el texto) pausa con el ratón encima o con el
    // foco. El botón de pausa NO: su estado explícito manda. Si el ratón o el foco sobre
    // el propio botón pausaran, «reanudar» con un clic o con Enter dejaría la rotación
    // congelada mientras el puntero o el foco sigan ahí (y el botón diría lo contrario).
    function leyendo(t) {
      var p = dentroDe(t, '.codm-resenas__pista');
      return !!(p && propio(p));
    }
    // ¿Un campo DEL ANFITRIÓN en el formulario abierto? (para no moverle los campos al
    // cliente si el CSS llega tarde). Solo eventos de verdad del usuario: el anfitrión
    // dispara change/input por código y hace focus() al abrir.
    function marcarTecleo(ev) {
      try {
        if (!ev || ev.isTrusted === false || !yo.estado.abierto || !yo.raiz) return;
        var t = ev.target;
        var tg = (t && t.nodeType === 1 && t.tagName) ? t.tagName.toUpperCase() : '';
        if (tg !== 'INPUT' && tg !== 'SELECT' && tg !== 'TEXTAREA') return;
        if (dentroDe(t, '[data-codm]') || !yo.raiz.contains(t)) return;
        yo.tecleo = true;
      } catch (e) {}
    }
    try {
      D.addEventListener('click', function (ev) {
        var b = dentroDe(ev.target, '[data-codm-pausa]');
        if (!b || !propio(b)) return;
        yo.rot.pausado = !yo.rot.pausado;
        b.setAttribute('aria-pressed', yo.rot.pausado ? 'true' : 'false');
        var box = propio(b);
        if (box) box.classList.toggle('codm-resenas--pausa', yo.rot.pausado);
      });
      D.addEventListener('mouseover', function (ev) { yo.rot.hover = leyendo(ev.target); });
      // El puntero sale de la ventana (no hay mouseover que lo apague).
      D.addEventListener('mouseout', function (ev) { if (!ev.relatedTarget) yo.rot.hover = false; });
      D.addEventListener('focusin', function (ev) { yo.rot.foco = leyendo(ev.target); });
      D.addEventListener('focusout', function () { yo.rot.foco = false; });
      D.addEventListener('input', marcarTecleo, true);
      D.addEventListener('change', marcarTecleo, true);
      D.addEventListener('pointerdown', marcarTecleo, true);
    } catch (e) {}
  };

  // Reloj del formulario abierto. Rotación por TIEMPO ACUMULADO (Date.now, con el
  // salto por iteración capado a un periodo: una pestaña en segundo plano no hace
  // girar diez reseñas de golpe). También vigila el cierre y la pantalla de éxito.
  Instancia.prototype.arrancarVigilia = function () {
    var yo = this;
    if (this.vigilia) clearTimeout(this.vigilia);
    var quieto = movimientoReducido() || this.resenas.length < 2 || !this.quiere('resenas');
    this.estado.rotando = !quieto;
    this.rot.ultimo = Date.now();
    function paso() {
      yo.vigilia = null;
      try {
        if (!yo.raiz || !D.documentElement.contains(yo.raiz)) {
          yo.cerrar();
          yo.raiz = null;
          yo.enganchar();
          return;
        }
        if (!yo.ad.abierto(yo.raiz)) { yo.cerrar(); return; }
        yo.ocultarPasosEnExito();
        if (yo.estado.rotando) {
          var ahora = Date.now();
          var dt = ahora - yo.rot.ultimo;
          yo.rot.ultimo = ahora;
          if (dt < 0) dt = 0;
          if (dt > PERIODO_MS) dt = PERIODO_MS;
          if (!yo.rot.pausado && !yo.rot.hover && !yo.rot.foco) yo.rot.acumulado += dt;
          var idx = indiceRotacion(yo.rot.acumulado, yo.resenas.length);
          if (idx !== yo.rot.idx) yo.pintarIndice(idx, false);
        }
      } catch (e) {}
      if (yo.estado.abierto) yo.vigilia = setTimeout(paso, VIGILIA_MS);
    }
    this.vigilia = setTimeout(paso, VIGILIA_MS);
  };

  // SOLO cambia clases (nunca texto, nunca nodos): el observador de puente-landing-co
  // no mira atributos, así que la rotación no lo despierta (M7).
  Instancia.prototype.pintarIndice = function (idx, forzar) {
    if (!this.raiz) return;
    var box = this.raiz.querySelector('[data-codm="resenas"]');
    if (!box) return;
    var slides = box.querySelectorAll('.codm-resena');
    if (!slides.length) return;
    if (idx >= slides.length) idx = 0;
    if (!forzar && idx === this.rot.idx) return;
    for (var i = 0; i < slides.length; i++) {
      var on = (i === idx);
      if (slides[i].classList.contains('codm-resena--on') !== on) slides[i].classList.toggle('codm-resena--on', on);
    }
    this.rot.idx = idx;
  };

  Instancia.prototype.ocultarPasosEnExito = function () {
    var p = this.raiz && this.raiz.querySelector('[data-codm="pasos"]');
    if (!p) return;
    var ex = false;
    try { ex = !!this.ad.exito(this.raiz); } catch (e) { ex = false; }
    if (p.classList.contains('codm--oculto') !== ex) p.classList.toggle('codm--oculto', ex);
  };

  // ═══════════════════════════════════════════════════════════════════════════
  // PÁGINA
  // ═══════════════════════════════════════════════════════════════════════════
  function movimientoReducido() {
    try { return !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; }
  }
  function hoyLocal() {
    var d = new Date();
    var m = d.getMonth() + 1, dd = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dd < 10 ? '0' : '') + dd;
  }
  function anguloDePagina() {
    var vals = [];
    try {
      var i, ns = D.querySelectorAll('[data-lh-angulo]');
      for (i = 0; i < ns.length; i++) vals.push(ns[i].getAttribute('data-lh-angulo'));
      // El propio JSON de reseñas del formulario también dice su ángulo (lh-compra).
      var rs = D.querySelectorAll('script[data-lh-resenas-form][data-angulo]');
      for (i = 0; i < rs.length; i++) vals.push(rs[i].getAttribute('data-angulo'));
    } catch (e) { return ANGULO_INCONSISTENTE; } // sin poder leer las marcas: sin rotador
    return anguloDeMarcas(vals);
  }
  function leerResenasHibrida() {
    var out = [];
    try {
      var ns = D.querySelectorAll('script[data-lh-resenas-form]');
      for (var i = 0; i < ns.length; i++) {
        var items = null;
        try { items = JSON.parse(ns[i].textContent || 'null'); } catch (e) { items = null; }
        if (!esArray(items)) continue;
        out.push({
          angulo: texto(ns[i].getAttribute('data-angulo')) || null,
          origen: texto(ns[i].getAttribute('data-origen')) || 'nuestras',
          items: items
        });
      }
    } catch (e) {}
    return out;
  }
  // Reseñas reales de TODA la tienda (solo las emite el snippet de Colombia).
  function leerResenasTienda() {
    try {
      var n = D.querySelector('script[data-codm-resenas-tienda]');
      if (!n) return [];
      var v = JSON.parse(n.textContent || 'null');
      if (v && !esArray(v) && esArray(v.items)) v = v.items;
      return esArray(v) ? v : [];
    } catch (e) { return []; }
  }
  var precargaPedida = false;
  function precargarCss(url) {
    if (precargaPedida || !url) return;
    precargaPedida = true;
    function ya() { try { cargarCss(url, null); } catch (e) {} }
    function ocioso() {
      if (typeof W.requestIdleCallback === 'function') { try { W.requestIdleCallback(ya, { timeout: 2000 }); return; } catch (e) {} }
      setTimeout(ya, 300);
    }
    if (D.readyState === 'complete') ocioso();
    else W.addEventListener('load', ocioso);
  }

  function escanear() {
    var ns;
    try { ns = D.querySelectorAll('script[data-cod-mejoras]'); } catch (e) { return; }
    for (var i = 0; i < ns.length; i++) {
      var sis = texto(ns[i].getAttribute('data-sistema'));
      if (!sis || Object.prototype.hasOwnProperty.call(API.instancias, sis)) continue;
      if (!Object.prototype.hasOwnProperty.call(SISTEMAS, sis)) { API.instancias[sis] = { estado: { activo: false, motivo: 'sistema_desconocido' } }; continue; }
      var inst = new Instancia(sis, ns[i]);
      API.instancias[sis] = inst;
      try { inst.iniciar(); } catch (e) { inst.estado.activo = false; inst.estado.motivo = 'error'; }
    }
  }

  var API = {
    version: VERSION,
    instancias: {},
    css: 'nada',
    escanear: escanear,
    // Lectura de diagnóstico para QA (sin datos de clientes).
    // ¿Está encendida la mejora 6 (`metaEnvio` | `tira2x1`) en el formulario de Colombia?
    // La consulta cod-co.js al abrir. false ante cualquier duda (sin instancia, inactiva,
    // grupo de control, clave desconocida).
    activa: function (nombre) {
      try {
        var inst = API.instancias.co;
        if (!inst || !inst.estado || inst.estado.activo !== true || !inst.m2) return false;
        if (nombre !== 'metaEnvio' && nombre !== 'tira2x1') return false;
        return inst.m2[nombre] === true;
      } catch (e) { return false; }
    },
    estado: function () {
      var out = {};
      for (var k in API.instancias) {
        if (Object.prototype.hasOwnProperty.call(API.instancias, k)) out[k] = API.instancias[k].estado;
      }
      return out;
    },
    _puras: {
      decidir: decidir, mejoras: mejoras, seleccionarResenas: seleccionarResenas,
      grupoDe: grupoDe, indiceRotacion: indiceRotacion, normalizarResena: normalizarResena,
      hablaDeEntrega: hablaDeEntrega, anguloDeMarcas: anguloDeMarcas,
      contarPalabras: contarPalabras, fotoValida: fotoValida, MAX_CHARS_RESENA: MAX_CHARS_RESENA,
      mejoras2x1: mejoras2x1,
      ANGULO_INCONSISTENTE: ANGULO_INCONSISTENTE,
      PERIODO_MS: PERIODO_MS, SISTEMAS: ['mx2', 'mx1', 'co', 'carrito-mx']
    }
  };
  W.__codMejoras = API;
  // Nombre corto que usa cod-co.js (ESPEC §7): sólo la decisión, nada más.
  if (!W.CodMejoras) W.CodMejoras = { activa: API.activa };

  try { escanear(); } catch (e) {}
  if (D.readyState === 'loading') {
    try { D.addEventListener('DOMContentLoaded', function () { try { escanear(); } catch (e) {} }); } catch (e) {}
  }
})();
